import { css } from "styled-components";
export default (({
  overflow
}) => css(["overflow:", ";"], overflow || "visible"));
//# sourceMappingURL=overflow.js.map